// extracted by mini-css-extract-plugin
export default {"appMainFooter":"AppFooter_appMainFooter__6elZs"};